<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">
                <dateselectionheader v-if="!indicatorDateView"
                        :label="dateSelectionStart.format('MMMM') + ' ' + dateSelectionStart.format('YYYY')"
                        @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'month'), true)"
                        @NextDate="setDateSelection(dateSelectionStart.add(1, 'month'), true)"
                        @CalendarOpen="OpenDateSelection"
                        @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>

                <div class="header date month" v-if="indicatorDateView">
                    <div class="fas fa-angle-left" v-on:click="indicatorDateView = null"></div>
                    <div class="label bold">{{indicatorDateView.format('dd').toUpperCase() + ', '}}</div>
                    <div class="label">{{indicatorDateView.format('DD') + '.' + indicatorDateView.format('MM') + '.'}}</div>
                    <div class="label">{{indicatorDateView.format('YYYY')}}</div>
                    <div class="fas fa-calendar" v-on:click="OpenDateSelection($event)"></div>
                </div>
            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>
        <div class ="tablecontainer scrollbar-container" :class="anonMode ? 'anonblur' : ''">
            <div v-if="planningIndicatorMap != undefined">
                <datatable :state="dataTableState"/>
            </div>

        </div>

        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
    </div>
</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import { mapState, mapGetters } from 'vuex';
const moment = require('moment-timezone');
import Papa from 'papaparse';
export default {
    name: 'storeplanningindicatorsoverview',
    components: {
        datatable,
    },
    data () {
        return {
        planningIndicatorMap:{},
        planningIndicatorTypeMap: {},
        recommendation: {},
        planningIndicatorId:"",
        currentPlanningIndicatorRow: undefined,
        planningIndicator: {
            id: null,
            amount: 0,
            typeId: null,
            planned: true,
            fromDate: null,
            fromTime: null,
            toDate: null,
            toTime: null,
            description: "",
        },
        sotecApiDataMap: {},
        dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ(),
        selectedRow: null,
        recommendationRows: [],
        planningIndicatorerror: false,
        showPlanned: true,
        recommendPlanned: true,
        indicatorDateView: null,
        indicatorDateMonth: this.$helpers.getCurrentMonthMomentTZ().date(1),
        loading: true,
        loadingText: this.$t('indicator.main.loadKeyFigures'),
        indicatorsByDayMap: {},
        minuteOffset: 0,
        }
    },
    created: function () {
        if(this.rosterFromTo != null){
            let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            this.setDateSelection(startDate, true);
        } else {
            this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ(), true);
        }
        if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'anonMode', 'isSuperUser', 'externalServicesMap', 'uiDataMap', 'storeSettings', 'sotecWebcockpitConfig']),
        planningIndicatorTypeCategoryMap() {
            let map = {};
            this.uiDataMap.planningIndicatorTypeCategories.forEach(category => {
                let item = {label: category.label_de, value: category.id};
                map[category.id] = item;
            })
            return map;
        },
        availablePlanningIndicatorTypeCategoryMap() {
            let map = {};
            this.uiDataMap.planningIndicatorTypeCategories.filter(cat => (Object.values(this.planningIndicatorTypeMap).filter(type => type.category == cat.id)).length == 0).forEach(category => {
                let item = {label: category.label_de, value: category.id};
                map[category.id] = item;
            })
            return map;
        },
        modalTableHeader(){
            let fields = [{key:"rec", thClass: 'documentsTh', tdClass: 'documentsTd', label:""},
                          {key:"date", thClass: 'documentsTh', tdClass: 'documentsTd', label:this.$t('store.settings.date')},
                          {key:"from", thClass: 'documentsTh', tdClass: 'documentsTd', label:this.$t('global.general.from')},
                          {key:"to", thClass: 'documentsTh', tdClass: 'documentsTd', label:this.$t('global.general.to')},]

            Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                fields.push({key: indicatorType.id, thClass: 'documentsTh', tdClass: 'documentsTd', label: indicatorType.name});
            })

            return fields;
        },
        headerButtons(){

                let view = this;

                let state= {
                    buttons: []
                };
                //BUTTON 1
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-sync-alt",
                    click: () => {
                       view.refresh(true);
                    },
                    tooltip: this.$t('global.general.refreshData')
                });
                state.buttons.push({
                        type: "block",
                        icon: "fa-exchange-alt",
                        click: ($event) => { this.OpenTransferIndicatorPopup($event); },
                        tooltip: this.$t('indicator.main.transferKeyFigures'),
                        helperText: this.$t('indicator.main.transferKeyFiguresHelp'),
                }),
                state.buttons.push({type: "block green border-r", icon: "fa-plus",click: ($event) => {view.AddIndicatorType($event)},tooltip: this.$t('indicator.main.addKeyFigure')});
                state.buttons.push({type: "block green", icon: "fa-layer-plus",click: ($event) => {view.openAddMultipleValues($event)},tooltip: this.$t('indicator.main.setMultiValue')});
                state.buttons.push({type: "block red", icon: "fa-times",click: ($event) => {view.OpenDeleteIndicatorByTypePopup($event)},tooltip: this.$t('indicator.main.deleteKeyFigureValues')});
                state.buttons.push({
                    type: view.showPlanned ? "block green" : "block orange",
                    icon: "fa-clone",
                    click: () => {
                        view.showPlanned = !view.showPlanned
                    },
                    tooltip: view.showPlanned ? this.$t('indicator.main.showsTargetData') : this.$t('indicator.main.showsActualData')
                });
                if(this.sotecWebcockpitConfig){
                    state.buttons.push({type: "block border-r", icon: "fa-cloud-download-alt",click: ($event) => {view.OpenSotecDataImportPopup($event)},tooltip: this.$t('indicator.main.importSotec')});
                }

                let currentTime = view.$helpers.getMomentTZ();
                if((this.isSuperUser|| this.storeId==420) && this.sotecWebcockpitConfig && currentTime.month() == view.dateSelectionStart.month() && currentTime.year() == view.dateSelectionStart.year() && currentTime.hours() > 6 ){
                    state.buttons.push({type: "block red border-r", icon: "fa-cloud-download",click: ($event) => { view.DoSotecCurrentDayImport();},tooltip: this.$t('indicator.main.importSotecDaily')});
                }

                if(this.indicatorDateView){
                    state.buttons.push({type: "block",icon: "fa-undo-alt",click: () => {view.indicatorDateView = null},tooltip: this.$t('indicator.main.backToOverview')});

                }

                state.helperLinks = [
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close')
                    }
                ];


                return state;
        },
        sideButtons() {
            let view = this;

            let state= {
                buttons: []
            };

            state.buttons.push({
                type: "block border-r",
                icon: "fa-print",
                tooltip: this.$t('global.ui.reportsExports'),
                click: ($event) => {view.OpenMenuDetails($event, this.reportMenuState)}
            },
            {
                type: "block border-r",
                icon: "fa-eye",
                tooltip: this.$t('global.ui.viewOptions'),
                click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState);},

            }
            );

            state.buttons.push({
                type: "block",
                icon: "fa-bars",
                tooltip: this.$t('global.ui.additionalOptions'),
                click: ($event) => {view.OpenMenuDetails($event, this.burgerMenuState)}
            });

            return state;
        },
        reportMenuState() {
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('pref.main.export'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: 'fa-file-csv',
                                    text: this.$t('indicator.main.exportCurrentAsCsv'),
                                    click: () => {
                                        view.exportCSV();
                                    }
                                }
                            ]
                        },

                    ],
                    items: []
            };
            return state;
        },
        burgerMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [
                    {
                        label: this.$t('pages.employeeContext.import'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: 'fa-file-csv',
                                disabled: false,
                                text: this.$t('global.ui.csvImport'),
                                click: () => {
                                    view.OpenCSVDataImportPopup();
                                }
                            }
                        ]
                    },
                    {
                        label: this.$t('pref.main.export'),
                        items: [
                            {
                                closeOnClick: true,
                                icon: 'fa-file-csv',
                                disabled: false,
                                text: this.$t('indicator.main.csvDataExport'),
                                click: () => {
                                    view.OpenCSVDataExportPopup();
                                }
                            }
                        ]
                    }

                ],
                items: []
            };


                return state;
        },
        displayMenuState(){
            let view = this;
            let state = {
                componentref: 'burgermenustate',
                groups: [],
                items: []
            };

            let group0 = {
                label: this.$t('global.ui.viewOptions'),
                items: [
                    {
                        closeOnClick: true,
                        icon: "fa-clock",
                        text: this.$t('indicator.main.setHourOffset'),
                        disabled: false,
                        show: true,
                        click: () => { view.OpenMinuteOffsetPopup()}
                    },


                ]
            };

            state.groups.push(group0);
            //state.groups.push(spotGroup);

            return state;
        },
        sotecWebcockpitId(){
            let sid = null;
            Object.values(this.externalServicesMap).forEach((s) => {

              if(s.name == "Sotec Webcockpit") sid = s.id;
            });
          return sid;
        },


        selectedRowLabel() {
            if(this.selectedRow){
                return this.selectedRow.dateMoment.format("DD.MM.YYYY HH")+":00 - "+this.selectedRow.dateMoment.clone().add(1,'hours').format("HH")+":00";
            } else {
                return "";
            }

        },

        dataTableState(){
            let view = this;
            let headerMap = {};

            headerMap['date'] = {label: this.$t('store.settings.date'), width: '150px', key:'date', DisplayLabel: i => i.date, align: view.indicatorDateView ? 'center' : 'sides', sort: (a, b) => { return view.$helpers.TimeDiff(a.dateMoment, b.dateMoment) < 0 ? -1 : 1}};
            Object.values(this.planningIndicatorTypeMap)
            .sort((a, b) => {
                let diff = a.priority - b.priority;
                if(diff != 0){
                    return diff;
                }  else {
                    return a.name.localeCompare(b.name);
                }
            })
            .forEach(i => headerMap[i.id] = {label: i.name, key: i.id, DisplayLabel: (item) => {
                    if(!view.indicatorDateView) {
                        let total = 0;
                        if(view.indicatorsByDayMap[i.id]){
                            if(view.showPlanned && view.indicatorsByDayMap[i.id].planned[item.dateKey]){
                                total = view.indicatorsByDayMap[i.id].planned[item.dateKey];
                            } else if(!view.showPlanned && view.indicatorsByDayMap[i.id].actual[item.dateKey]){
                                total = view.indicatorsByDayMap[i.id].actual[item.dateKey];
                            }
                        }

                        total = total / Math.pow(10, i.fractional);
                        return ''+total.toFixed(2);
                    } else {
                        let total = 0;
                        if(item.indicator && item.indicator.typeId === i.id){
                            total = item.indicator.amount
                        }
                        total = total / Math.pow(10, i.fractional);
                        return ''+total.toFixed(2);

                    }
                },
                align: 'center',
                OnChange: false,
                button: {icon: 'fas fa-pencil-alt', action: this.IndicatorTypeContextPopup},
                tooltip: i.isDefault ? "Standard" : null,
                data: i,
            });


            let buttons = [];
            if(view.indicatorDateView) {

                buttons.push({icon: 'fas fa-pencil-alt', action: ($event, item) => {
                    view.EditIndicator({currentTarget: $event.currentTarget}, item, item.dateMoment.hours());
                }});
                buttons.push({icon: 'fas fa-trash', action: ($event, indicator) => {
                    view.deletePlanningIndicator(indicator.indicator);
                }});
            }
            headerMap['plannedSelect'] = {key: 'plannedSelect', width: '170px', buttons: buttons,
                label: view.showPlanned ?'Soll' :this.$t('workBalance.summary.actual'),
                alignCenter: true,
            };
            let data = [];
            let dateGroups = {};

            if(!this.indicatorDateView) {
                let start = this.dateSelectionStart.clone().startOf('month');
                let end = start.clone().add(1,'months');
                let indicatorTypes = Object.values(this.planningIndicatorTypeMap).map(entry => entry.id);
                while(end.diff(start) > 0){

                    let dayTime = start.clone();
                    let dateKey = dayTime.format("YYYY-MM-DD");


                    let row = {date: start.format('DD.MM.YY') + ' ' + this.$helpers.translateWeekday(start.format('dddd')), indicatorTypes: indicatorTypes, dateMoment: start.clone(), dateKey: dateKey};

                    row.OnChange = {};
                    row.buttons = {};
                    row.dropdown = {};
                    row.dropdown['plannedSelect'] = false;
                    row.buttons['plannedSelect'] = [];
                    row.buttons['plannedSelect'].push({
                                                    icon: 'fas fa-eye', tooltip: this.$t('pref.main.detail'), action: ($event, indicatorGroup) => {
                                                            view.indicatorDateView = indicatorGroup.dateMoment
                                                        }
                                                    });

                    row.indicatorTypes.forEach(typeId => {
                        row.OnChange[typeId] = (newVal, rowData, headerKey) => {
                            let oldValue = 0;
                            if(view.indicatorsByDayMap[headerKey]){
                                if(view.showPlanned && view.indicatorsByDayMap[headerKey].planned[rowData.dateKey]){
                                    oldValue = view.indicatorsByDayMap[headerKey].planned[rowData.dateKey];
                                } else if(!view.showPlanned && view.indicatorsByDayMap[headerKey].actual[rowData.dateKey]){
                                    oldValue = view.indicatorsByDayMap[headerKey].actual[rowData.dateKey];
                                }
                            }
                            view.DistributeAndSumEditDaily(oldValue, newVal, typeId, view.showPlanned, row.dateMoment);

                        };
                    })


                    data.push(row);
                    start = start.add(1,'days');
                }

            } else {
                for(let x = 0; x < 24; x++) {
                    let row = {};
                    let date = view.indicatorDateView.clone().hours(x).minutes(0).seconds(0).millisecond(0);
                    if(this.minuteOffset > 0){
                        date = date.add(this.minuteOffset, 'minutes');
                    }
                    row.dateMoment = date;
                    row.date = date.format("HH")+":00 - "+date.clone().add(1,'hours').format("HH")+":00";
                    row.subEntries = [];
                    row.indicatorTypes = Object.values(this.planningIndicatorTypeMap).map(entry => entry.id);
                    row.displayLabel = {};
                    row.dropdown = {};
                    row.dropdown['plannedSelect'] = false;
                    row.buttons = {};
                    let countMap = {};
                    row.buttons['plannedSelect'] = [
                            {icon: 'fas fa-plus', action: ($event, item) => {
                            let dateFrom =  date.clone();
                            let dateTo =  date.clone().minutes(15);
                            view.EditIndicator({currentTarget: $event.currentTarget}, {indicator: {from: view.$helpers.convertDateStringTZ(dateFrom), to: view.$helpers.convertDateStringTZ(dateTo), amount: 0, description: '', planned: view.showPlanned}}, item.dateMoment.hours());
                            }}];

                    let dateKey = row.dateMoment.format("YYYY-MM-DD-HH");
                    if(this.planningIndicatorTimeMap[dateKey]){
                        this.planningIndicatorTimeMap[dateKey].filter(entry => entry.indicator.planned === view.showPlanned).forEach(entry => {
                            let i = entry.indicator;
                            let dateFrom = entry.dateMoment;

                            let dateTo = view.$helpers.getMomentFromStringTZ(i.to);
                            if(!row.displayLabel[i.typeId]) row.displayLabel[i.typeId] = 0;
                            row.displayLabel[i.typeId] += i.amount;
                            if(!countMap[i.typeId]){
                                countMap[i.typeId] = 0;
                            }
                            countMap[i.typeId] +=1
                            let subEntry = {
                                date: dateFrom.format('HH:mm') + '-' + dateTo.format('HH:mm'),
                                indicator: i,
                                dateMoment: date,
                                OnChange: {},
                            }
                            subEntry.OnChange[i.typeId] = (newVal, rowData, headerKey) => {
                                let indicators =  [];
                                indicators.push(rowData.indicator);
                                view.DistributeSumAndEdit(indicators, newVal, i.typeId, dateTo);
                            };
                            row.subEntries.push(subEntry);
                        });
                        Object.keys(countMap).forEach(k => {
                            if(view.planningIndicatorTypeMap[k].sumBehavior == 2){
                                row.displayLabel[k] = row.displayLabel[k]/Math.max(1, countMap[k]);
                            }
                        })
                    }


                    for(let label in row.displayLabel){
                        if(this.planningIndicatorTypeMap[label]){
                            row.displayLabel[label] = (row.displayLabel[label] /  Math.pow(10, this.planningIndicatorTypeMap[label].fractional)).toFixed(2);
                        }
                    }

                    row.OnChange = {};
                    row.indicatorTypes.forEach(typeId => {
                        row.OnChange[typeId] = (newVal, rowData, headerKey) => {
                            let indicators =  rowData.subEntries.map(sub => sub.indicator).filter(ind => ind.planned === view.showPlanned && ind.typeId === headerKey);
                            view.DistributeSumAndEdit(indicators, newVal, typeId, row.dateMoment);
                        };
                    })



                    data.push(row);
                }
            }

            let dataSum = [];

            if(!this.indicatorDateView) {
                let temp = {};
                temp['date'] = {label: this.$t('shift.template.total'), key: 'date', align: 'left'};
                Object.values(this.planningIndicatorTypeMap).forEach(i => {
                    let total = 0;
                    let totalCount = 0;
                    let map = {};
                    if(view.indicatorsByDayMap[i.id] && view.showPlanned){
                        map = view.indicatorsByDayMap[i.id].planned;
                    } else if(view.indicatorsByDayMap[i.id] && !view.showPlanned){
                        map = view.indicatorsByDayMap[i.id].actual;
                    }
                    let start = this.dateSelectionStart.clone().startOf('month');
                    let end = start.clone().add(1,'months');

                    while(end.diff(start) > 0){
                        let dayTime = start.clone();

                        let dateKey = dayTime.format("YYYY-MM-DD");
                        if(map[dateKey]){
                            let val = map[dateKey];
                            total+= val;
                            if(val != 0){
                                totalCount+=1;
                            }

                        }
                        start = start.add(1,'days');
                    }
                    if(i.sumBehavior == 2){
                        if(totalCount > 0){
                            total = total/totalCount;
                        }
                    }

                    temp[i.id] = {label: (total/Math.pow(10, i.fractional)).toFixed(2), key: i.id, OnChange: false};
                });
                dataSum.push(temp);
            } else {
                let totalRow = {};
                totalRow['date'] = {
                    label: this.$t('shift.template.total'), key: 'date', align: 'left'
                };
                let differenceRow = {};
                differenceRow['date'] = {
                    label: this.$t('roster.view.difference'), key: 'date', align: 'left'
                };
                Object.values(this.planningIndicatorTypeMap).forEach(i => {
                    let totalPlanned = 0;
                    let plannedCount = 0;
                    let totalUnplanned = 0;
                    let unplannedCount = 0;

                    Object.values(view.planningIndicatorMap).filter(ind => ind.typeId === i.id && view.$helpers.getMomentFromStringTZ(ind.from).add(-1*this.minuteOffset, 'minutes').format('YYYY-MM-DD') === view.indicatorDateView.format('YYYY-MM-DD')).forEach(ind => {
                        if(ind.planned){
                            totalPlanned += ind.amount;
                            plannedCount +=1;
                        } else {
                            totalUnplanned += ind.amount;
                            unplannedCount +=1;
                        }
                    });
                    if(i.sumBehavior == 2){
                        if(plannedCount > 0){
                            totalPlanned = totalPlanned/plannedCount;
                        }
                        if(unplannedCount > 0){
                            totalUnplanned = totalUnplanned/unplannedCount;
                        }
                    }

                    let difference = totalUnplanned - totalPlanned;
                    let total = view.showPlanned ? totalPlanned : totalUnplanned
                    totalRow[i.id] = {label: (total/Math.pow(10, i.fractional)).toFixed(2), key: i.id, OnChange: false};
                    differenceRow[i.id] = {label: (difference/Math.pow(10, i.fractional)).toFixed(2), key: i.id};
                });
                dataSum.push(totalRow);
                dataSum.push(differenceRow);
            }

            return {
                headerMap: headerMap,
                data: data,
                dataSum: dataSum,
            };
        },
        rosterFromTo() {
            if(this.$store.state.loggedIn){
                return this.$store.state.rosterFromTo;
            } else {
                return null;
            }
        },
        monthDisplay: function() {
            if(this.dateSelectionStart != null){
                return this.dateSelectionStart.format('MMM YYYY');
            } else {
                return '-';
            }

        },
        planningIndicatorTimeMap() {
            console.log('timemap');
            let view = this;
            let map = {};

            Object.values(this.planningIndicatorMap).forEach(indicator => {
                let dateMoment = view.$helpers.getMomentFromStringTZ(indicator.from);
                let timeKey = this.$helpers.getMomentFromStringTZ(indicator.from).format("YYYY-MM-DD-HH");
                if(!map[timeKey]){
                        map[timeKey] = [];
                }
                let entry = {indicator: indicator, dateMoment: dateMoment};
                map[timeKey].push(entry);
            });
            return map;
        }
    },
    watch: {
        rosterFromTo(newVal, oldVal) {
            if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();
            }
        },
        storeId(newVal, oldVal) {
            this.refresh();
        },
        recommendationRows: {
            handler: function(newVal, oldVal){
                this.updateRecommendation()
            },
            deep: true,
        },
        recommendPlanned(newVal, oldVal){
            this.recommendationRows = this.computeRecommendationRows();
        },
        indicatorDateView(newVal, oldVal){
            let view = this;
            if(!view.loading){
                view.loading = true;
                if(view.indicatorDateView){
                    let from = view.indicatorDateView.clone()
                    let to = view.indicatorDateView.clone().add(1, 'days')
                     if(view.minuteOffset > 0){
                        from = from.add(view.minuteOffset, 'minutes');
                        to = to.add(view.minuteOffset, 'minutes');
                    }
                    from = from.format();
                    to = to.format();
                    let map = {};
                    return view.loadPlanningIndicatorsPagedCompletely(from, to, 1, []).then(data => {
                        view.updatePlanningIndicators(data, map);
                        view.loading = false;
                    });
                } else {
                    let from = view.$helpers.getMomentFromStringTZ(view.$store.state.rosterFromTo.from).subtract(6, 'week').format();
                    let to = view.$store.state.rosterFromTo.to;
                    let map = {};
                    view.loading = true;
                    return view.loadPlanningIndicatorsGroupedByDay(from, to)
                    .then(data => {
                        data.data.forEach(item => {
                            if(!map[item.typeId]){
                                map[item.typeId] = {planned: {}, actual: {}};
                            }
                            if(item.planned){
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].planned[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].planned[item.date] = item.sumAmount;
                                }

                            } else {
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].actual[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].actual[item.date] = item.sumAmount;
                                }
                            }
                        })

                        let lastYearFrom = view.$helpers.getCurrentMonthMomentTZ().subtract(1, 'year');
                        let from = lastYearFrom.format();
                        let to = lastYearFrom.add(1,'month').format();
                        return view.loadPlanningIndicatorsGroupedByDay(from, to);
                    }).then(data => {
                        data.data.forEach(item => {
                            if(!map[item.typeId]){
                                map[item.typeId] = {planned: {}, actual: {}};
                            }
                            if(item.planned){
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].planned[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].planned[item.date] = item.sumAmount;
                                }

                            } else {
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].actual[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].actual[item.date] = item.sumAmount;
                                }
                            }
                        })
                        view.indicatorsByDayMap = map;
                        view.loading = false;

                    })
                }
            }
        }

    },
    // methods that implement data logic.
    methods: {
        DoSotecCurrentDayImport(){
            let view = this;
            view.$helpers.DoSotecLiveDataImport().then(() => {
                view.refresh(true);
            }).catch(error => {
                console.log("Fehler: Fehler beim Live Data Import!");

            });
        },
        OpenMenuDetails($event, state){
            let view = this;

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: state,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        async DistributeAndSumEditDaily(oldVal, newVal, typeId, planned, date, toast = true){
            let view = this;
            let from = date.clone().startOf('day');
            let to = from.clone().add(1, 'days');
            if(this.minuteOffset > 0){
                from = from.add(this.minuteOffset, 'minutes');
                to = to.add(this.minuteOffset, 'minutes');
            }

            return new Promise((resolve, reject) => {
                view.loadPlanningIndicators(from.format(), to.format(), planned, typeId).then(response => {
                    return view.DistributeSumAndEdit(response.data, newVal, typeId, date, toast);
                }).then(res => {
                    if(view.indicatorsByDayMap[typeId]){
                        let map = planned ? view.indicatorsByDayMap[typeId].planned : view.indicatorsByDayMap[typeId].actual;
                        let dateKey = date.format("YYYY-MM-DD");
                        view.$set(map, dateKey, res);
                    }
                    resolve();
                }).catch(error=> {
                    console.log(error);
                    if(view.indicatorsByDayMap[typeId]){
                        let map = planned ? view.indicatorsByDayMap[typeId].planned : view.indicatorsByDayMap[typeId].actual;
                        let dateKey = date.format("YYYY-MM-DD");
                        view.$set(map, dateKey, oldVal);
                    }
                    this.$helpers.error(this.$t('global.notifications.error'), this.$t('workBalance.averages.updatedDataError'));
                    reject(error);
                });
            });

        },
        DistributeSumAndEdit(indicators, newVal, typeId, datetime, toast = true){
            let view = this;
            let nv = newVal != null ? newVal.replace(',', '.') : newVal;
            if(isNaN(parseFloat(nv))) {
                return new Promise((resolve, reject) => {reject()});
            }
            let newSum = parseFloat(nv);

            if(newSum < 0){
                if(toast){
                    this.$helpers.error(this.$t('indicator.main.negativeAmount'), this.$t('indicator.main.negativeAmountsNotAllowed'));
                }
                return new Promise((resolve, reject) => {reject()});

            }
            //can only distribute among non imported values, so we can only perform this action if newsum > imported sum
            let importedSum = 0;
            /*indicators.filter(i => i.imported).forEach(i=>{
                importedSum += i.amount;
            });
            importedSum =  importedSum / Math.pow(10, this.planningIndicatorTypeMap[typeId].fractional);  */
            let remainingSum = newSum - importedSum;
            if(remainingSum < 0){
                remainingSum = 0;
            }
            if(indicators.length == 0){

                return new Promise((resolve, reject) => {
                    let indicator = {
                        typeId: typeId,
                        amount: Math.floor(remainingSum * Math.pow(10, this.planningIndicatorTypeMap[typeId].fractional)),
                        from: datetime.clone().startOf('hour').format(),
                        to: datetime.clone().startOf('hour').add(1,'hours').format(),
                        planned: this.showPlanned
                    }
                    let createIndicators = [];
                    createIndicators.push(indicator);
                    view.createPlanningIndicatorsMulti(createIndicators, toast)
                    .then(success => {
                        resolve((importedSum+remainingSum) * Math.pow(10, view.planningIndicatorTypeMap[typeId].fractional));
                    }).catch(error => {
                        reject(error)
                    });
                });

            } else {
                return new Promise((resolve, reject) => {
                    let redistributedIndicators = view.DistributeSum(indicators, newSum);
                    view.editPlanningIndicatorsMulti(redistributedIndicators, toast)
                    .then(success => {
                        resolve((importedSum+remainingSum) * Math.pow(10, view.planningIndicatorTypeMap[typeId].fractional));
                    }).catch(error => {
                        reject(error)
                    });
                });

            }

        },

        DistributeSum(indis, ns){
            //can only distribute among non imported values
            let importedSum = 0;
            /*indis.filter(i => i.imported).forEach(i=>{
                importedSum += (i.amount / Math.pow(10, this.planningIndicatorTypeMap[i.typeId].fractional));
            }); */
            let newSum = ns - importedSum;
            if(newSum < 0){
                newSum = 0;
            }
            //CALCULATE SUM AND PORPORTION FIRST
            let indicators = indis //.filter(i => !i.imported);
            let sum = 0;

            indicators.forEach(i => {
                sum+=i.amount;
            });

            let proportionMap = {};
            if(sum > 0){
                indicators.forEach(i => {
                    let proportion = i.amount/sum;
                    proportionMap[i.id] = proportion;
                });
            } else {
                indicators.forEach(i => {
                let proportion = 1/indicators.length;
                proportionMap[i.id] = proportion;
                });
            }

            let remainder = newSum;
            //distribute newSum among indicators according to original sum proportion;
            indicators.forEach(i => {
                let proportionalAmount = Math.floor(newSum * proportionMap[i.id]);
                i.amount = proportionalAmount * Math.pow(10, this.planningIndicatorTypeMap[i.typeId].fractional);
                remainder -= proportionalAmount;

            });
            if(remainder > 0){
                indicators[0].amount+= (remainder * Math.pow(10, this.planningIndicatorTypeMap[indicators[0].typeId].fractional));
            }
            return indicators;
        },
        acceptRecommendation() {
            let view = this;
            let recommendation = this.recommendation;
            Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                if(recommendation[indicatorType.id] > 0){
                    recommendation.typeIds[indicatorType.id] = true;
                }
            });

            let selectedDate = this.selectedRow.dateMoment;
            let selectedDateTo = selectedDate.clone().add(1,'hours');
            let dateKey = selectedDate.format("YYYY-MM-DD-HH")
            let editableIndicators = [];
            let creatableIndicators = [];

            if(this.indicatorDateView){
                Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                    let create = false;

                    if(recommendation.typeIds[indicatorType.id]){
                        if(this.planningIndicatorTimeMap[dateKey]){
                            let indicators = this.planningIndicatorTimeMap[dateKey].map(i => i.indicator).filter(i => i.typeId == indicatorType.id && i.planned === view.showPlanned);
                            if(indicators.length > 0){
                                indicators = this.DistributeSum(indicators, recommendation[indicatorType.id]);
                                editableIndicators = editableIndicators.concat(indicators);
                            } else {
                                create = true;
                            }
                        } else {
                            create = true;
                        }
                    }
                    if(create){
                        let recommendationValue = Math.round(recommendation[indicatorType.id] * Math.pow(10, indicatorType.fractional));
                        let indicator = {
                            typeId: indicatorType.id,
                            description: "",
                            from: selectedDate.format(),
                            to: selectedDateTo.format(),
                            amount: recommendationValue,
                            planned: view.showPlanned,
                        }
                        creatableIndicators.push(indicator);
                    }

                });
            } else {
                let hours=["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","23"];
                Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                    let create = false;

                    if(recommendation.typeIds[indicatorType.id]){
                        let hoursCreateCheck = false;
                        let indicators = [];
                        hours.forEach(hour => {
                            let dateKey = selectedDate.format("YYYY-MM-DD-")+hour;
                            if(this.planningIndicatorTimeMap[dateKey]){
                                this.planningIndicatorTimeMap[dateKey]
                                .map(i => i.indicator)
                                .filter(i => i.typeId == indicatorType.id && i.planned === view.showPlanned)
                                .forEach(indicator => indicators.push(indicator));
                            }
                        });
                        if(indicators.length > 0){
                            indicators = this.DistributeSum(indicators, recommendation[indicatorType.id]);
                            editableIndicators = editableIndicators.concat(indicators);
                        } else {
                            create = true;
                        }

                    }
                    if(create){
                        let recommendationValue = Math.round(recommendation[indicatorType.id] * Math.pow(10, indicatorType.fractional));
                        let indicator = {
                            typeId: indicatorType.id,
                            description: "",
                            from: selectedDate.format(),
                            to: selectedDateTo.format(),
                            amount: recommendationValue,
                            planned: view.showPlanned,
                        }
                        creatableIndicators.push(indicator);
                    }

                });
            }


            if(editableIndicators.length > 0){
                this.editPlanningIndicatorsMulti(editableIndicators);
            }
            if(creatableIndicators.length > 0){
                this.createPlanningIndicatorsMulti(creatableIndicators);
            }

        },

        computeRecommendationRows() {

            let view = this;
            let rowDates = [];
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(1,"years"));
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(6,"weeks"));
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(5,"weeks"));
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(4,"weeks"));
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(3,"weeks"));
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(2,"weeks"));
            rowDates.push(this.selectedRow.dateMoment.clone().subtract(1,"weeks"));



            let rows = [];
            if(this.indicatorDateView){
                rowDates.forEach(rowDate => {
                    let row = {rec: "", date: rowDate.format("DD.MM.YYYY"), from: rowDate.format("HH")+":00", to: rowDate.clone().add(1,'hours').format("HH")+":00", resultrow: false};
                    let typeIds = {};
                    Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                        let amount = 0;
                        if(this.planningIndicatorTimeMap[rowDate.format("YYYY-MM-DD-HH")]){
                            Object.values(this.planningIndicatorTimeMap[rowDate.format("YYYY-MM-DD-HH")])
                            .map(i => i.indicator)
                            .filter(i => i.planned === view.recommendPlanned && i.typeId == indicatorType.id)
                            .forEach(i => {
                                typeIds[i.typeId] = true;
                                amount+=i.amount;
                            });
                        }

                        row[indicatorType.id] = amount;
                        if(amount > 0){
                            row['checked-'+indicatorType.id] = true;
                        } else {
                            row['checked-'+indicatorType.id] = false;
                        }
                    });
                    row.typeIds = typeIds;
                    if(Object.keys(row.typeIds).length == 0){
                        row.checked = false;
                    }
                    rows.push(row);
                });
            } else {
                let hours=["00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","20","21","23"];
                rowDates.forEach(rowDate => {
                    let row = {rec: "", date: rowDate.format("DD.MM.YYYY"), from: "00:00", to: "24:00", resultrow: false};
                    let typeIds = {};
                    Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                        let amount = 0;
                        hours.forEach(hour => {
                            let dateKey = rowDate.format("YYYY-MM-DD-")+hour;
                            if(this.planningIndicatorTimeMap[dateKey]){
                                Object.values(this.planningIndicatorTimeMap[dateKey])
                                .map(i => i.indicator)
                                .filter(i => i.planned === view.recommendPlanned && i.typeId == indicatorType.id)
                                .forEach(i => {
                                    typeIds[i.typeId] = true;
                                    amount+=i.amount;
                                });
                            }
                        });
                        row[indicatorType.id] = amount;
                        if(amount > 0){
                            row['checked-'+indicatorType.id] = true;
                        } else {
                            row['checked-'+indicatorType.id] = false;
                        }
                    });
                    row.typeIds = typeIds;
                    if(Object.keys(row.typeIds).length == 0){
                        row.checked = false;
                    }
                    rows.push(row);
                });
            }

            let row = {rec: "Empfehlung", date: "", from: "", to:"", resultrow: true, checked: false};
            let recommendation = {};
            let typeIds = {};
            let countMap = {};
            Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                let amount = 0;
                let applicableRows = rows.filter(row => !row.resultrow);

                if(applicableRows.length > 0){
                    applicableRows.forEach(r => {
                        if(r['checked-'+indicatorType.id]){
                            if(r.typeIds[indicatorType.id]){
                                typeIds[indicatorType.id] = true;
                            }
                            amount+=r[indicatorType.id];
                            if(!countMap[indicatorType.id]){
                               countMap[indicatorType.id] = 0;
                            }
                            countMap[indicatorType.id] +=1
                        }

                    });
                    if(countMap[indicatorType.id] > 0){
                        row[indicatorType.id] = Math.floor(amount/countMap[indicatorType.id]);
                        recommendation[indicatorType.id] = (row[indicatorType.id]/Math.pow(10, indicatorType.fractional)).toFixed(2);
                    } else {
                        row[indicatorType.id] = 0;
                        recommendation[indicatorType.id] = (row[indicatorType.id]/Math.pow(10, indicatorType.fractional)).toFixed(2);
                    }

                } else {
                    row[indicatorType.id] = 0;
                    recommendation[indicatorType.id] = (row[indicatorType.id]/Math.pow(10, indicatorType.fractional)).toFixed(2);
                }
            });
            row.typeIds = typeIds;
            recommendation.typeIds = row.typeIds;
            rows.push(row);
            this.recommendation = recommendation;

            return rows;

        },
        updateRecommendation(){

            let typeIds = {};
            let recommendation = {};
            let countMap = {};
            Object.values(this.planningIndicatorTypeMap).forEach(indicatorType => {
                let amount = 0;
                let applicableRows = this.recommendationRows.filter(row => !row.resultrow);

                if(applicableRows.length > 0){
                    applicableRows.forEach(r => {
                        if(r['checked-'+indicatorType.id]){
                            if(r.typeIds[indicatorType.id]){
                                typeIds[indicatorType.id] = true;
                            }

                            amount+=r[indicatorType.id];
                            if(!countMap[indicatorType.id]){
                               countMap[indicatorType.id] = 0;
                            }
                            countMap[indicatorType.id] +=1;
                        }

                    });
                    if(countMap[indicatorType.id] > 0){
                        recommendation[indicatorType.id] = Math.floor(amount/countMap[indicatorType.id]);
                        recommendation[indicatorType.id] = (recommendation[indicatorType.id]/Math.pow(10, indicatorType.fractional)).toFixed(2);
                    } else {
                        recommendation[indicatorType.id] = 0;
                        recommendation[indicatorType.id] = (recommendation[indicatorType.id]/Math.pow(10, indicatorType.fractional)).toFixed(2);
                    }


                } else {
                    recommendation[indicatorType.id] = 0;
                    recommendation[indicatorType.id] = (recommendation[indicatorType.id]/Math.pow(10, indicatorType.fractional)).toFixed(2);

                }
            });
            recommendation.typeIds = typeIds;
            this.recommendation = recommendation;

        },
        OpenMinuteOffsetPopup(){
            let view = this;

                let dataEntries = [];



                dataEntries.push({label: this.$t('indicator.main.hourOffset'), key: 'minuteOffset', type: 'slider', hidden: false, value: this.minuteOffset,
                    slider: {hideMin: true, hideMax: true, min: 0, max: 23*60, value: this.minuteOffset, step: 60,
                        DisplayLabel: (val) => { return val/60+"h"}, inputControl: true, sliderInput: (x) => {return x * 60},
                        labelToInt: (x) => {return Number(x.slice(0, -1)) * 60}, shorterDisplayLabel: (x) => {return x / 60}},
                })

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,

                        selectCallback: function (data) {
                           view.minuteOffset = data.minuteOffset;
                           view.refresh();

                        }
                    },
                    header: this.$t('indicator.main.hourOffset'),
                    width: "700px",
                    expanded: true,
                    centered: true
                });
        },
        EditIndicator($event, item, fixedHour){
            let view = this;
            let indicator = item.indicator;
            let amount = indicator.amount;
            if(indicator.typeId){
                let type = this.planningIndicatorTypeMap[indicator.typeId];
                amount = amount / Math.pow(10,type.fractional);
            }
            let entries = [
                {label: 'id', key: 'id', hidden: true, type: 'text', value: indicator.id},
                {label: this.$t('global.general.from'), key: 'from', hidden: true, type: 'text', value: view.$helpers.getMomentTZ(indicator.from).seconds(0).millisecond(0)}];
            if(!this.indicatorDateView){
                entries.push(
                    {label: this.$t('store.settings.date'), key: 'date', hidden: false, type: 'date', value: view.$helpers.getMomentTZ(indicator.from).seconds(0).millisecond(0)});
            }
            entries.push({label: 'typeId', key: 'typeId', hidden: true, type: 'text', value: indicator.typeId});
            /*if(!indicator.id) indicator.from.minutes(0);
            if(!indicator.id) indicator.to.minutes(15);*/
            if(!fixedHour) entries.push({label: this.$tc('global.ui.hours'), key: 'hour', hidden: false, type: 'numeric', length: 2, min: 0, max: 23, flexGroup: true, value: view.$helpers.getMomentFromStringTZ(indicator.from).hours()});
            if(fixedHour) entries.push({label: this.$tc('global.ui.hours'), key: 'hour', hidden: false, type: 'numeric', length: 2, min: 0, max: 23, flexGroup: true, value: fixedHour, disabled: !indicator.id});
            entries.push({label: this.$t('indicator.main.fromMinutes'), key: 'fromMinute', hidden: false, type: 'numeric', length: 2, min: 0, max: 59, flexGroup: true, value: view.$helpers.getMomentFromStringTZ(indicator.from).minutes()});
            entries.push({label: this.$t('indicator.main.toMinutes'), key: 'toMinute', hidden: false, type: 'numeric', length: 2, min: 0, max: 59, flexGroup: true, value: view.$helpers.getMomentFromStringTZ(indicator.to).minutes()});
            /*entries.push({key: 'quarter', hidden: false, selectSingle: true, flexGroup: true, type: 'togglelist', toggleEntries: [
                    {label:'00', value: 0, selected: true},
                    {label:'15', value: 15, selected: false},
                    {label:'30', value: 30, selected: false},
                    {label:'45', value: 45, selected: false},
                ], styles: {width: '325px'}
            });*/
            if(!indicator.typeId) {
                let typeItems = [];
                Object.values(this.planningIndicatorTypeMap).forEach(i => typeItems.push({label: i.name, value: i.id, selected: false}));
                entries.push({label: this.$tc('global.general.type'), key: 'typeId', hidden: false, type: 'dropdownsearch', selectMultiple: false, dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: typeItems,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: {},
                        onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                        selectFirst: true,
                        placeholder: 'Type',
                    }, styles: {width: '342px'}});
            }
            entries.push({label: this.$t('store.events.description'), key: 'description', hidden: false, type: 'text', value: indicator.description, length: 30});
            entries.push({label: this.$t('workBalance.summary.target'), key: 'planned', hidden: false, type: 'bool', value: indicator.planned});
            entries.push({label: this.$t('indicator.main.amount'), key: 'amount', hidden: false, type: 'numeric', value: amount, length: 30});
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: entries,
                    selectCallback: function (indicator) {
                        //if(!fixedHour) indicator.fromMinute = 0;
                        //if(!fixedHour) indicator.toMinute = 59;
                        if(indicator.fromMinute > indicator.toMinute) indicator.toMinute = indicator.fromMinute + 5;
                        if(indicator.toMinute > 59) indicator.toMinute = 59;
                        indicator.from.hours(indicator.hour).minutes(indicator.fromMinute);

                        if(!view.indicatorDateView) {
                            indicator.from.month(indicator.date.month());
                            indicator.from.year(indicator.date.year());
                            indicator.from.date(indicator.date.date());
                        } else {
                            indicator.from.month(view.indicatorDateView.month());
                            indicator.from.year(view.indicatorDateView.year());
                            indicator.from.date(view.indicatorDateView.date());
                        }
                        indicator.to = indicator.from.clone();
                        indicator.to.minutes(indicator.toMinute);
                        indicator.amount = indicator.amount * Math.pow(10, view.planningIndicatorTypeMap[indicator.typeId].fractional);
                        if(indicator.id) view.editPlanningIndicator(indicator);
                        else view.createPlanningIndicator(indicator);
                    },
                    deleteCallback: !indicator.id ? null : (indicator) => {
                        view.$helpers.OpenAlert({
                            header: this.$t('indicator.main.deleteKeyFigure'),
                            description: this.$t('indicator.main.deleteKeyFigureQuery'),
                            callbackAccept: function(popup){
                                view.deletePlanningIndicator(indicator);
                                popup.hidden = true;
                            }, callbackCancel: function(popup){
                                popup.loading = false;
                                popup.hidden = true;
                            }})},
                },
                header: indicator.id ? this.$t('indicator.main.editKeyFigure') : this.$t('indicator.main.addKeyFigure'),
                expanded: true,
                centered: true
            });
        },
        IndicatorTypeContextPopup($event, type){
            let view = this;
            let list = [{
                label: this.$t('roster.comp.standard'), type: type,
                selectCallback: function ($event, indicatorType) {
                    view.$helpers.OpenAlert({
                        header: view.$t('indicator.main.standardType'),
                        description: view.$t('indicator.main.standardTypeQuery'),
                    callbackAccept: function(popup){
                        view.makeDefault(indicatorType.type);
                        popup.hidden = true;
                    }, callbackCancel: function(popup){
                        popup.loading = false;
                        popup.hidden = true;
                    }});
                }
            },{
                label: view.$t('global.ui.edit'), type: type,
                selectCallback: function ($event, indicatorType) {
                    view.EditIndicatorType({currentTarget: $event.currentTarget}, indicatorType.type);
                }
            },{
                label: view.$t('global.ui.delete'), type: type,
                selectCallback: function ($event, indicatorType) {
                    let type = indicatorType.type;
                    view.DeleteIndicatorTypePopup(type);

                }
            }];
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'list',
                componentState: {
                    entries: list,
                },
                pinTopRight: true,
            });
        },
        AddIndicatorType($event){
            let view = this;
            let sumBehaviors = [{label: this.$t('global.ui.sum'), value: 1}, {label: this.$t('store.settings.average'), value: 2}];
            let selectedsumBehavior = sumBehaviors[0];

            let categories = [{label: "Keine Kategorie", value: null}];

            Object.values(view.availablePlanningIndicatorTypeCategoryMap).forEach(c => {
                categories.push(c);
            });
            let selectedCategory = categories[0];
            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: '', length: 30},
                        {label: this.$t('indicator.vlh.unit'), key: 'unit', hidden: false, type: 'text', value: '', length: 30},
                        {label: this.$t('indicator.main.decimalPlaces'), key: 'fractional', hidden: true, type: 'slider', value: 7, slider: {min: 2, hideMin: true, hideMax: true, max: 7, value: 7}},
                        {label: this.$t('indicator.main.sumModus'), key: 'sumBehavior', type: 'dropdownsearch', hidden: false, value: selectedsumBehavior.value,
                            dropdownSearchState: {
                                selectMultiple: false, styleLight: true,
                                items: sumBehaviors,
                                selectedItem: selectedsumBehavior
                            }
                        },
                        {label: this.$t('pages.employeeContract.category'), key: 'category', type: 'dropdownsearch', hidden: false, value: selectedCategory ? selectedCategory.value : null,
                            dropdownSearchState: {
                                selectMultiple: false, styleLight: true,
                                items: categories,
                                selectedItem: selectedCategory
                            }
                        },
                        {label: this.$t('global.ui.prio'), key: 'priority', hidden: false, type: 'slider', value: 1, slider: {min: 1, max: 100, inputControl: true, hideMin: true, hideMax: true, value: 1}},
                    ],
                    selectCallback: function (indicatorType) {
                        console.log(indicatorType)
                        view.createPlanningIndicatorType(indicatorType);
                    }
                },
                header: this.$t('indicator.main.newKeyFigure'),
                width: "600px",
                expanded: true,
                centered: true,
            });
        },
        EditIndicatorType($event, indicatorType){
            let view = this;
            let sumBehaviors = [{label: this.$t('global.ui.sum'), value: 1}, {label: this.$t('store.settings.average'), value: 2}];
            let selectedsumBehavior = sumBehaviors.find(item => item.value == indicatorType.sumBehavior);

            let categories = Object.values(view.availablePlanningIndicatorTypeCategoryMap).slice();
            categories.push({label: "Keine Kategorie", value: null});
            let selectedCategory = Object.values(view.planningIndicatorTypeCategoryMap).find(item => item.value == indicatorType.category);
            if(selectedCategory != null){
                categories.push(selectedCategory);
            }
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {label: 'Id', key: 'id', hidden: true, type: 'text', value: indicatorType.id},
                        {label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: indicatorType.name, length: 30},
                        {label: this.$t('indicator.vlh.unit'), key: 'unit', hidden: false, type: 'text', value: indicatorType.unit, length: 30},
                        {label: this.$t('indicator.main.decimalPlaces'), key: 'fractional', hidden: true, type: 'slider', value: indicatorType.fractional, slider: {min: 2, max: 7,  hideMin: true, hideMax: true, value: indicatorType.fractional > 2 ? indicatorType.fractional : 2}},
                        {label: this.$t('indicator.main.sumModus'), key: 'sumBehavior', type: 'dropdownsearch', hidden: false, value: selectedsumBehavior.value,
                            dropdownSearchState: {
                                selectMultiple: false, styleLight: true,
                                items: sumBehaviors,
                                selectedItem: selectedsumBehavior
                            }
                        },
                        {label: this.$t('pages.employeeContract.category'), key: 'category', type: 'dropdownsearch', hidden: !view.isSuperUser, value: selectedCategory ? selectedCategory.value : null,
                            dropdownSearchState: {
                                selectMultiple: false, styleLight: true,
                                items: categories,
                                selectedItem: selectedCategory
                            }
                        },
                        {label: this.$t('global.ui.prio'), key: 'priority', hidden: false, type: 'slider', value: indicatorType.priority, slider: {min: 1, max: 100, inputControl: true, hideMin: true, hideMax: true, value: indicatorType.priority}},
                    ],
                    selectCallback: function (indicatorType) {
                        view.editPlanningIndicatorType(indicatorType);
                    },
                    deleteCallback: (indicatorType) => {
                        let type = indicatorType;
                        view.DeleteIndicatorTypePopup(type)

                    }
                },
                header: view.$t('indicator.main.editKeyFigureType'),
                expanded: true,
            });
        },
        DeleteIndicatorTypePopup(type){
            let view = this;
            let description =
                              this.$t('indicator.main.deleteKeyFigureHelp1', [type.name]) + "<br/>"+
                              "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <ul>"+
                              "<li>" + this.$t('indicator.main.deleteKeyFigureHelp2') + "</li>"+
                              "<li>" + this.$t('indicator.main.deleteKeyFigureHelp3') + "</li></ul><br>"+
                              this.$t('indicator.main.deleteKeyFigureHelp4');
            let dataEntries = [];

            dataEntries.push({label: this.$t('indicator.main.confirmDelete'), key: "confirmDelete", hidden: false, type: 'text', value: ''});


            view.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                                (entries) => {
                                    if(entries['confirmDelete'] == null || entries['confirmDelete'] != type.name){
                                        return {key: 'confirmDelete', type: 'error', label: this.$t('global.notifications.error'), text: view.$t('pages.employeeContext.confirmInvalid')}
                                    } else {
                                        return null
                                    }
                                },

                    ],
                    description: description,
                    selectCallback: function (data) {
                        if(data.confirmDelete == type.name){
                            view.deletePlanningIndicatorType(type);
                        } else {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.main.deleteUnconfirmed'));
                        }

                    }
                },
                header: this.$t('indicator.main.deleteKeyFigureNamed', [type.name]),
                expanded: true,
                centered: true
            });
        },
        openAddMultipleValues($event) {
            let view = this;

            let typeIdItems = [];
            Object.values(this.planningIndicatorTypeMap).forEach(s => typeIdItems.push({ label: s.name, value: s.id }));

            let dataEntries = [
                {
                    label: this.$t('roster.view.keyFigure'),
                    key: 'typeId',
                    hidden: false,
                    type: 'dropdownsearch',
                    value: null,
                    selectMultiple: false,
                    dropdownSearchState: {
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: typeIdItems,
                        selectMultiple: false,
                        selectedItems: [],
                        onceSelected: function($event, item, searchbar) {
                        },
                        styleLight: true,
                    },
                },
                { label: this.$t('workBalance.extraPay.value'), key: 'indicatorValue', hidden: false, type: 'numeric', value: 0.00 },
                {
                    label: this.$t('global.general.from'),
                    key: 'from',
                    type: 'datetimeframe',
                    value: this.dateSelectionStart.clone().startOf('month'),
                },
                {
                    label: this.$t('global.general.to'),
                    key: 'to',
                    type: 'datetimeframe',
                    value: this.dateSelectionStart.clone().startOf('month').clone().add(1, 'months').subtract(1, 'days'),
                },
            ];

            let limitFrom = this.dateSelectionStart.clone().startOf('month');
            let limitEnd = limitFrom.clone().add(1,'months').add(-1,'days');

            this.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [
                        (entries) => {
                            if(!entries.typeId) {
                                return {key: 'typeId', type: 'error', label: this.$t('roster.view.keyFigure'), text: this.$t('indicator.vlh.pleaseSelectKeyFigure')}
                            }
                        },
                        (entries) => {
                            if (entries.from > entries.to) {
                                return {key: 'from', type: 'error', label: this.$t('global.general.from'), text: this.$t('indicator.meo.startBeforeEnd')}
                            } else {
                                return null;
                            }
                        },
                        (entries) => {
                            if (entries.from < limitFrom || entries.from > limitEnd) {
                                return {key: 'from', type: 'error', label: this.$t('global.general.from'), text: this.$t('indicator.main.currentMonth')}
                            } else {
                                return null;
                            }
                        },
                        (entries) => {
                            if (entries.to < limitFrom || entries.to > limitEnd) {
                                return {key: 'to', type: 'error', label: this.$t('global.general.to'), text: this.$t('indicator.main.currentMonth')}
                            } else {
                                return null;
                            }
                        },
                    ],
                    selectCallback: function(item) {
                        view.createIndicators(item);
                    },
                },
                header: this.$t('indicator.main.setKeyFigures'),
                expanded: true,
                centered: true,
            });
        },
        async createIndicators(item) {
            let view = this;

            let from = item.from;
            let to = item.to;
            let typeId = item.typeId;
            let indicatorValue = item.indicatorValue;
            view.loading = true;
            view.loadingText = this.$t('indicator.main.creatingKeyFigures');

            await this.executeDistributeAndSumEditDaily(
                from, to, 0,
                indicatorValue + '',
                typeId,
                view.showPlanned,
                from,
            );
            view.loadingText = '';
            view.loading = false;
            this.refresh();
        },
        async executeDistributeAndSumEditDaily(from, to, counter, newVal, typeId, planned, date) {
            this.loadingText = this.$t('indicator.main.keyFigureCreatedFor', [from.format('DD.MM.YYYY')]);

            await this.DistributeAndSumEditDaily(this.getOldValue(typeId, from.format('YYYY-MM-DD')), newVal, typeId, planned, date, false);

            from.add(1, 'days');
            if (from > to) {
                return;
            }
            await this.executeDistributeAndSumEditDaily(from, to, counter, newVal, typeId, planned, date);
        },
        getOldValue(typeId, dateKey) {
            let oldValue = 0;
            if(this.indicatorsByDayMap[typeId]){
                if(this.showPlanned && this.indicatorsByDayMap[typeId].planned[dateKey]){
                    oldValue = this.indicatorsByDayMap[typeId].planned[dateKey];
                } else if(!this.showPlanned && this.indicatorsByDayMap[typeId].actual[dateKey]){
                    oldValue = this.indicatorsByDayMap[typeId].actual[dateKey];
                }
            }
            return oldValue;
        },
        OpenDeleteIndicatorByTypePopup($event){
            let view = this;
            let from = this.indicatorDateMonth.clone();
            let to = from.clone().add(1, 'months');

            let typeIdItems = [];
            Object.values(view.planningIndicatorTypeMap).forEach(s => typeIdItems.push({label: s.name, value: s.id}));
            let plannedItems = [{label: this.$t('workBalance.summary.target'), value: true}, {label: this.$t('workBalance.summary.actual'), value: false}];
            let importedItems = [{label: this.$t('global.ui.no'), value: false}, {label: this.$t('global.ui.yes'), value: true}];
            let dataEntries = [
                    {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'datetimeframe', timeBig: false, startTime: false, value: from, focusProceedKey: 'to'},
                    {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'datetimeframe', timeBig: false, startTime: false, value: to, focusProceedKey: 'from'},
                    {label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeIdItems,
                            selectMultiple: false,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                    }},
                    {label: this.$t('indicator.main.targetActual'), key: 'planned', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: plannedItems,
                            selectMultiple: false,
                            selectedItems: [plannedItems[0]],
                            selectedItem: plannedItems[0],
                            onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                    }},
                    {label: this.$t('indicator.main.importedValues'), key: 'imported', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: importedItems,
                            selectMultiple: false,
                            selectedItems: [importedItems[0]],
                            selectedItem: importedItems[0],
                            onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                    }},

            ];
            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                        view.deletePlanningIndicatorByTypeId(item);
                    }
                },
                header: this.$t('indicator.main.deleteKeyFigureValues'),
                pointerDirection: 1,
                expanded: true,
                centered: true,
            });

        },
        OpenTransferIndicatorPopup($event){
            let view = this;
            let from = this.indicatorDateMonth.clone();
            let to = from.clone().add(1, 'months');

            let typeIdItems = [];
            Object.values(view.planningIndicatorTypeMap).forEach(s => typeIdItems.push({label: s.name, value: s.id}));
            let description = "<b style='color: red'>" + this.$t('global.ui.warning') + ":</b> <br/>"+
                              this.$t('indicator.main.transferHelp');

            let dataEntries = [
                    {label: this.$t('indicator.main.transferredKeyFigure'), key: 'sourceId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeIdItems,
                            selectMultiple: false,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                    }},
                    {label: this.$t('indicator.main.targetKeyFigure'), key: 'targetId', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeIdItems,
                            selectMultiple: false,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                    }},
                    {label: this.$t('indicator.main.fromDate'), key: 'from', hidden: false, type: 'datetimeframe', timeBig: false, startTime: false, value: from, focusProceedKey: 'to'},
                    {label: this.$t('indicator.main.toDate'), key: 'to', hidden: false, type: 'datetimeframe', timeBig: false, startTime: false, value: to, focusProceedKey: 'from'},
                    {label: this.$t('indicator.main.calculateWithTaxRate'), key: 'useTax', hidden: false, type: 'bool', value: false},
                    {label: this.$t('indicator.main.averageTaxRate'), key: 'tax', hidden: this.$helpers.CheckDatafillKeysForHidden('useTax'), type: 'text', value: '10.0'},
                    {label: this.$t('workBalance.summary.multiplier'), key: 'factor', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('useTax'), type: 'text', value: '1.0'},



            ];
            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    errorCheck: [
                                    (entries) => {
                                        if(entries['sourceId'] == null){
                                            return {key: 'sourceId', type: 'error', label: this.$t('indicator.main.transferredKeyFigure'), text: this.$t('indicator.main.pleaseSelectValue')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries['targetId'] == null){
                                            return {key: 'targetId', type: 'error', label: this.$t('indicator.main.targetKeyFigure'), text: this.$t('indicator.main.pleaseSelectValue')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        if(entries['sourceId'] == entries['targetId']){
                                            return {key: 'targetId', type: 'error', label: this.$t('indicator.main.targetKeyFigure'), text: this.$t('indicator.main.sameOriginAndTarget')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        let fValue = entries["factor"].replace(',', '.');
                                        fValue = parseFloat(fValue);
                                        if(!entries["useTax"] && (isNaN(fValue) || fValue == null || fValue == Infinity || fValue < 0 || fValue > 10)){
                                            return {key: 'factor', type: 'error', label: this.$t('indicator.main.factor'), text: this.$t('indicator.main.factorHelp')}
                                        } else {
                                            return null
                                        }
                                    },
                                    (entries) => {
                                        let fValue = entries["tax"].replace(',', '.');
                                        fValue = parseFloat(fValue);
                                        if(entries["useTax"] && (isNaN(fValue) || fValue == null || fValue == Infinity || fValue < 0)){
                                            return {key: 'tax', type: 'error', label: this.$t('indicator.main.averageTaxRate'), text: this.$t('indicator.main.averageTaxRateHelp')}
                                        } else {
                                            return null
                                        }
                                    },
                                ],
                    selectCallback: function (item) {
                        item.factor = item.factor.replace(',', '.');
                        item.tax = item.tax.replace(',', '.');
                        let f = parseFloat(item.useTax ? item.tax : item.factor);
                        if(item.useTax){
                            f = 1.0 / (1.0 + f/100)
                        }
                        let payload = {
                            sourceId: item.sourceId,
                            targetId: item.targetId,
                            from: item.from.format(),
                            to: item.to.format(),
                            factor: f,
                            planned: view.showPlanned
                        }
                        view.transferPlanningIndicator(payload);
                    }
                },
                header: (view.showPlanned ? this.$t('shift.main.plan') : this.$t('workBalance.summary.actual')) + ' ' + this.$t('indicator.main.transferKeyFigures'),
                pointerDirection: 1,
                width: "700px",
                expanded: true,
                centered: true,
            });

        },
        transferPlanningIndicator: function(payload){
            let view = this;
            let url = '/api/sec/planningindicator/transfer';

            let params = {
                storeId: this.$store.state.storeId,

            }

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$helpers.success(view.$t('indicator.main.transferSuccessful'), view.$t('indicator.main.keyFigureValuesTransferred'))
                view.refresh();
            }).catch(function (error) {
                view.$helpers.error(view.$t('indicator.main.transferFailed'), view.$t('indicator.main.keyFigureTransferError'))
                //view.refresh();
                console.log(error)
            })

        },
        deletePlanningIndicatorByTypeId: function(item){
            let view = this;
            let url = '/api/sec/planningindicator/typeid';

            let params = {
                storeId: this.$store.state.storeId,
                typeId: item.typeId,
                from: item.from.format(),
                to: item.to.format(),
                planned: item.planned,
                imported: item.imported,
            }



            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                view.$helpers.success(view.$t('shift.template.deleted'), view.$t('indicator.main.keyFigureValuesDeleted'))
                view.refresh();
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('indicator.main.deleteKeyFigureValuesError'))
                console.log(error)
            })

        },
        OpenSotecDataImportPopup($event){
            let view = this;
            let from = this.indicatorDateMonth.clone();

            let dates = [];
            let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
            let endDate = startDate.clone().add(1, 'months')
            while(startDate < endDate){
                dates.push({label: startDate.format("DD.MM.YYYY"), value: startDate.clone()});
                startDate = startDate.add(1, 'days')
            }

            let dataEntries = [

                {label: this.$tc('global.general.day'), key: 'from', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: dates,
                            selectMultiple: false,
                            selectFirst: true,
                            selectedItems: [],
                            onceSelected: function ($event, item, searchbar){
                        },
                        styleLight: true,
                }},
            ];
            let target = $event.currentTarget;

            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    selectCallback: function (item) {
                        view.importSotecActualData(item);
                    }
                },
                header: this.$t('indicator.main.webActualDataImport'),
                pointerDirection: 1,
                expanded: true,
                centered: true,
            });

        },
        importSotecActualData: function(item){
            let view = this;
            let url = '/api/sec/sotecactualdata/import';

            let params = {
                storeId: this.storeId,
                from: item.from.startOf('day').format(),
                to: item.from.clone().startOf('day').add(1, 'days').format(),
            }



            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                params: params
            }).then(response => {
                view.$helpers.success(view.$t('store.settings.importSuccessful'), view.$t('indicator.main.keyFigureValuesImported'))
                view.refresh();
            }).catch(function (error) {
                view.$helpers.error(view.$t('store.settings.importError'), view.$t('workBalance.payroll.importKeyFiguresError'))
                console.log(error)
            })

        },
        OpenCSVDataExportPopup(){
            let view = this;

            let typeItems = Object.values(this.planningIndicatorTypeMap).sort((a, b) => a.name.localeCompare(b.name)).map(item => {return {label: item.name, value: item.id}})
            let modeItems = [{label: this.$t('store.settings.planData'), value: 1}, {label: this.$t('store.api.actualData'), value: 2}]

            let dataEntries = [
                {label: this.$t('roster.view.keyFigure'), key: 'typeId', disabled: false, hidden: false, type: 'dropdownsearch', value: null, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },
                {label: this.$t('indicator.main.dataType'), key: 'dataType', disabled: false, hidden: false, type: 'dropdownsearch', value: null, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: modeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },

            ];


            this.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    errorCheck: [

                        (entries) => {
                            if(entries['typeId'] ==  null){
                                return {key: 'typeId', type: 'error', label: this.$t('roster.view.keyFigure'), text: this.$t('indicator.vlh.pleaseSelectKeyFigure')}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            if(entries['dataType'] ==  null){
                                return {key: 'dataType', type: 'error', label: this.$t('indicator.main.dataType'), text: this.$t('indicator.main.pleaseSelectDataType')}
                            } else {
                                return null
                            }
                        },

                    ],
                    selectCallback: function (data) {
                        let from = view.dateSelectionStart.clone().startOf('month');
                        let to = from.clone().add(1,'months');
                        view.loadPlanningIndicatorsPagedCompletely(from.format(), to.format(), 1, [], data.typeId, data.dataType == 1)
                        .then(res => {
                            view.exportForImportCSV(res, view.planningIndicatorTypeMap[data.typeId]);
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('indicator.main.exportFailed'), view.$t('indicator.main.exportKeyFigureValuesError'))
                            console.log(error)
                        })
                    }
                },
                header: this.$t('indicator.main.csvDataExport'),
                pointerDirection: 1,
                expanded: true,
                centered: true,
            });

        },
        OpenCSVDataImportPopup(){
            let view = this;
            let description ="<p>" + this.$t('indicator.main.importHelp1') + "<p>"+
                            "<p>" + this.$t('indicator.main.importHelp2') + "</p>"+
                            "<p>" + this.$t('indicator.main.example') + ": <b style='color: red'>"+this.$helpers.getMomentTZ().format("DD.MM.YYYY HH:mm")+"</b></p>"+
                            "<p>" + this.$t('indicator.main.importHelp3') + "</p>";
            let typeItems = Object.values(this.planningIndicatorTypeMap).sort((a, b) => a.name.localeCompare(b.name)).map(item => {return {label: item.name, value: item.id}})
            let modeItems = [{label: this.$t('store.settings.planData'), value: 1}, {label: this.$t('store.api.actualData'), value: 2}]

            let dataEntries = [
                {label: this.$t('global.ui.csvFile'), accept: ".csv", key: 'file', hidden: false, type: 'file', value: null},
                {label: this.$t('roster.view.keyFigure'), key: 'typeId', disabled: false, hidden: false, type: 'dropdownsearch', value: null, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: typeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },
                {label: this.$t('indicator.main.dataType'), key: 'dataType', disabled: false, hidden: false, type: 'dropdownsearch', value: null, flexGroup: false,
                        dropdownSearchState:{
                            toggled: false,
                            displayedItems: [],
                            input: '',
                            items: modeItems,
                            selectMultiple: false,
                            selectedItems: [],
                            selectedItem: null,
                            onceSelected: function ($event, item, searchbar){
                            },
                            styleLight: true,
                            placeholder: this.$t('store.settings.pleaseSelect'),
                          }
                },

            ];


            this.$helpers.OpenPopup({
                type: 'datafill',
                componentState: {
                    entries: dataEntries,
                    description: description,
                    errorCheck: [
                        (entries) => {
                            if(entries['file'] ==  null){
                                return {key: 'file', type: 'error', label: this.$t('global.ui.file'), text: this.$t('global.ui.pleaseSelectFile')}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            if(entries['typeId'] ==  null){
                                return {key: 'typeId', type: 'error', label: this.$t('roster.view.keyFigure'), text: this.$t('indicator.vlh.pleaseSelectKeyFigure')}
                            } else {
                                return null
                            }
                        },
                        (entries) => {
                            if(entries['dataType'] ==  null){
                                return {key: 'dataType', type: 'error', label: this.$t('indicator.main.dataType'), text: this.$t('indicator.main.pleaseSelectDataType')}
                            } else {
                                return null
                            }
                        },

                    ],
                    selectCallback: function (data) {
                        view.parseCSVImport(data.file[0], data.typeId, data.dataType == 1)
                        .then(data => {
                            return view.importPlanningIndicators(data);

                        }).then(data => {
                            view.refresh(true);
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('store.settings.importError'), view.$t('workBalance.payroll.importKeyFiguresError'))
                            console.log(error)
                        })
                    }
                },
                header: this.$t('global.ui.csvDataImport'),
                pointerDirection: 1,
                expanded: true,
                centered: true,
            });

        },
        parseCSVImport(file, typeId, planned = true){
            let view = this;
            return new Promise((resolve, reject) => {
                Papa.parse(file,
                {   delimiter: ";",
                    skipEmptyLines: true,
                    complete: (result, file) => {
                        let convertedResults = [];
                        let type = view.planningIndicatorTypeMap[typeId];

                        let timeValueMap = {}
                        result.data.forEach(row => {
                            if(row.length >= 2){
                                let from = view.$helpers.getMomentFromStringTZ(row[0], "DD.MM.YYYY HH:mm")
                                let val = row[1];
                                if(val != null){
                                    val = val.replace(',', '.')
                                }
                                val = parseFloat(val);
                                if(from != null && val != null && !isNaN(val) && from != 'Invalid date'){
                                    const roundedDown = Math.floor(from.minute() / 15) * 15;
                                    from.minute(roundedDown).second(0);
                                    if(!timeValueMap[from.format()]){
                                        timeValueMap[from.format()] = 0;
                                    }
                                    timeValueMap[from.format()] += val;
                                    }
                            }
                        })
                        let monthFrom = view.dateSelectionStart.clone().startOf('month');
                        let monthTo = monthFrom.clone().add(1, 'month');
                        Object.keys(timeValueMap).forEach(key => {
                            let to = view.$helpers.getMomentFromStringTZ(key).add(15, 'minutes');
                            if(to > monthFrom && to <= monthTo){
                                convertedResults.push({from: key,
                                                   to: to.format(),
                                                   typeId: typeId,
                                                   amount: Math.round(timeValueMap[key] * Math.pow(10, type.fractional)),
                                                   planned: planned})
                            }


                        })

                        resolve(convertedResults);
                    },
                    error: (error, file) => {
                        reject(error);

                    }
                })
            })

        },
        OpenDateSelection($event){
            let view = this;
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: this.indicatorDateView ? ['D'] : ['M'], date: this.indicatorDateView ? this.indicatorDateView.clone() : this.dateSelectionStart.clone() },
                {
                    OnDateSelect: (date) => { view.onDatePicked(date) },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
        editPlanningIndicatorType: function(indicatorType){
            let view = this;
            this.$helpers.EditCall('/api/sec/planningindicatortype', indicatorType,
                response => {
                view.$store.commit("invalidateState", {states: ['planningIndicatorTypeMapState']});
                view.refresh();

            });
        },
        createPlanningIndicatorType: function(indicatorType){
            let view = this;
            let url = '/api/sec/planningindicatortype';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');


            let payload = {
                storeId: this.$store.state.storeId,
                name: indicatorType.name,
                unit: indicatorType.unit,
                fractional: 7,
                sumBehavior: indicatorType.sumBehavior,
                category: indicatorType.category,
                priority: indicatorType.priority
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                view.$store.commit("invalidateState", {states: ['planningIndicatorTypeMapState']});
                view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.main.keyFigureTypCreated'))
                view.$set(view.planningIndicatorTypeMap, response.data.data.id, response.data.data);

            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.main.createKeyFigureTypeError'))
                console.log(error)
            })

        },
        deletePlanningIndicatorType: function(indicatorType){
            let view = this;
            let url = '/api/sec/planningindicatortype';

            url = this.$helpers.appendParam("id", indicatorType.id, url, '/api/sec/planningindicatortype');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');

            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$store.commit("invalidateState", {states: ['planningIndicatorTypeMapState']});
                view.$helpers.success(view.$t('shift.template.deleted'), view.$t('indicator.main.keyFigureTypeDeleted'))
                view.$delete(view.planningIndicatorTypeMap, indicatorType.id);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('indicator.main.deleteKeyFigureTypeError'))
                console.log(error)
            })

        },
        makeDefault: function(indicatorType){

            let view = this;
            let url = '/api/sec/planningindicatortype/default';

            let params = {
                id: indicatorType.id,
                storeId: this.$store.state.storeId
            }



            this.axios({
                method: 'put',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$store.commit("invalidateState", {states: ['planningIndicatorTypeMapState']});

                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('indicator.main.keyFigureTypeEdited'))
                view.refresh();
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('indicator.main.editKeyFigureTypeError'))
                console.log(error)
            })

        },
        toggleDatePicker($event) {
            let view = this;
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: ['M'], date: this.dateSelectionStart.clone() },
                {
                    OnDateSelect: (date) => { view.setDateSelection(date) },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
        setDateSelection(date, calculateRosterFromTo){
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;
            if(this.indicatorDateView) {
                this.indicatorDateView = date.clone();
            } else {
                this.indicatorDateMonth = date.clone().startOf('month');
            }
            if(calculateRosterFromTo){
                //update vuex store with calculated from to => triggers reload of data via refresh
                let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
                this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
            } else {
                //dont update vuex from to, only update client side view
            }
        },
        onDatePicked(date){
            this.setDateSelection(date, true);
        },
        refresh: function(){
            let view = this;
            this.loading = true;
            this.loadPlanningIndicatorTypes()
            .then(response => {
                view.updatePlanningIndicatorTypes(response.data);
                if(view.indicatorDateView){
                    let from = view.indicatorDateView.clone()
                    let to = view.indicatorDateView.clone().add(1, 'days')

                    if(view.minuteOffset > 0){
                        from = from.add(view.minuteOffset, 'minutes');
                        to = to.add(view.minuteOffset, 'minutes');
                    }
                    from = from.format();
                    to = to.format();
                    let map = {};
                    return view.loadPlanningIndicatorsPagedCompletely(from, to, 1, []).then(data => {
                        view.updatePlanningIndicators(data, map);
                        return view.$helpers.GetSotecWebcockpitConfig();
                    });
                } else {
                    let from = view.$helpers.getMomentFromStringTZ(view.$store.state.rosterFromTo.from).subtract(6, 'week').format();
                    let to = view.$store.state.rosterFromTo.to;
                    let map = {};
                    return view.loadPlanningIndicatorsGroupedByDay(from, to)
                    .then(data => {
                        data.data.forEach(item => {
                            if(!map[item.typeId]){
                                map[item.typeId] = {planned: {}, actual: {}};
                            }
                            if(item.planned){
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].planned[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].planned[item.date] = item.sumAmount;
                                }

                            } else {
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].actual[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].actual[item.date] = item.sumAmount;
                                }
                            }
                        })

                        let lastYearFrom = view.$helpers.getCurrentMonthMomentTZ().subtract(1, 'year');
                        let from = lastYearFrom.format();
                        let to = lastYearFrom.add(1,'month').format();
                        return view.loadPlanningIndicatorsGroupedByDay(from, to);
                    }).then(data => {
                        data.data.forEach(item => {
                            if(!map[item.typeId]){
                                map[item.typeId] = {planned: {}, actual: {}};
                            }
                            if(item.planned){
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].planned[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].planned[item.date] = item.sumAmount;
                                }

                            } else {
                                if(view.planningIndicatorTypeMap[item.typeId] && view.planningIndicatorTypeMap[item.typeId].sumBehavior == 2){
                                    map[item.typeId].actual[item.date] = item.avgAmount;
                                } else {
                                    map[item.typeId].actual[item.date] = item.sumAmount;
                                }
                            }
                        })
                        view.indicatorsByDayMap = map;
                        return view.$helpers.GetSotecWebcockpitConfig();

                    })
                }

            }).then(data => {
                return view.$helpers.GetExternalServicesMap();
            }).then(data=>{

                view.loading = false;
            }).catch(function (error) {
                console.log(error)
            })

        },
        openEditModal: function(row){
            this.currentPlanningIndicatorRow = row;
            this.planningIndicatorId = row.item.id;
            this.planningIndicator.id = row.item.id;
            this.planningIndicator.amount = row.item.amount;
            this.planningIndicator.typeId = row.item.typeId;
            this.planningIndicator.planned = row.item.planned;
            this.planningIndicator.description = row.item.description;
            this.planningIndicator.fromDate = this.$helpers.getMomentFromStringTZ(row.item.from).format("YYYY-MM-DD");
            this.planningIndicator.fromTime = this.$helpers.getMomentFromStringTZ(row.item.from).format("HH:mm");
            this.planningIndicator.toDate = this.$helpers.getMomentFromStringTZ(row.item.to).format("YYYY-MM-DD");
            this.planningIndicator.toTime = this.$helpers.getMomentFromStringTZ(row.item.to).format("HH:mm");


            this.showModal('modal-editplanningIndicator');
        },
        getPlanningIndicatorPlannedText(planned){
            if(planned){
                return this.$t('workBalance.summary.target');
            } else {
                return this.$t('workBalance.summary.actual');
            }
        },
        editPlanningIndicator: function(indicator){
            let view = this;
            let url = '/api/sec/planningindicator';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicator');

            let payload = {
                id: indicator.id,
                updateFields:["amount", "typeId", "from", "to", "planned", "description"],
                amount: indicator.amount,
                typeId: indicator.typeId,
                from: indicator.from,
                to: indicator.to,
                planned: indicator.planned,
                description: indicator.description,
            }



            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {
                if(view.planningIndicatorMap[payload.id]){
                    view.$set(view.planningIndicatorMap[payload.id], 'from', payload.from);
                    view.$set(view.planningIndicatorMap[payload.id], 'to', payload.to);
                    view.$set(view.planningIndicatorMap[payload.id], 'amount', payload.amount);
                    view.$set(view.planningIndicatorMap[payload.id], 'typeId', payload.typeId);
                    view.$set(view.planningIndicatorMap[payload.id], 'planned', payload.planned);
                    view.$set(view.planningIndicatorMap[payload.id], 'description', payload.description);
                }

                view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('indicator.main.keyFigureEdited'));


            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('indicator.main.editKeyFigureError'));
                console.log(error)
            })

        },
        createPlanningIndicator: function(indicator){
            let view = this;
            let url = '/api/sec/planningindicator';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicator');

            let payload = {
                updateFields:["amount", "typeId", "from", "to", "planned", "description"],
                amount: indicator.amount,
                typeId: indicator.typeId,
                from: indicator.from,
                to: indicator.to,
                planned: indicator.planned,
                description: indicator.description,
            }



            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                view.$set(view.planningIndicatorMap, response.data.data.id, response.data.data);
                view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.main.keyFigureCreated'));


            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.main.createKeyFigureError'));
                console.log(error)
            })

        },
        editPlanningIndicatorsMulti: function(indicators, toast = true){
            let view = this;
            let url = '/api/sec/planningindicator/multi';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicator/multi');
            let requests = [];
            indicators.forEach(indicator => requests.push({
                    id: indicator.id,
                    from: indicator.from,
                    to: indicator.to,
                    amount: indicator.amount,
                    typeId: indicator.typeId,
                    description: indicator.description,
                    planned: indicator.planned,
                    updateFields:["from", "to", "amount", "typeId", "description", "planned"]
            }));
            let payload = {
                requests: requests,
            };


            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {

                    response.data.data.forEach(id => {
                        let updatedValues = payload.requests.find(req => req.id == id);
                        if(view.planningIndicatorMap[payload.id]){
                            view.$set(view.planningIndicatorMap[id], 'from', updatedValues.from);
                            view.$set(view.planningIndicatorMap[id], 'to', updatedValues.to);
                            view.$set(view.planningIndicatorMap[id], 'amount', updatedValues.amount);
                            view.$set(view.planningIndicatorMap[id], 'typeId', updatedValues.typeId);
                            view.$set(view.planningIndicatorMap[id], 'planned', updatedValues.planned);
                            view.$set(view.planningIndicatorMap[id], 'description', updatedValues.description);
                        }

                    });
                    if(toast){
                        view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('indicator.main.keyFiguresEdited'));
                    }
                    resolve();


                }).catch(function (error) {
                    if(toast){
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('indicator.main.editKeyFiguresError'));
                    }
                    console.log(error)
                    reject(error);

                })
            });


        },
        createPlanningIndicatorsMulti(indicators, toast = true) {
            let view = this;
            let url = '/api/sec/planningindicator/multi';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                requests: indicators
            }
            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    if(toast){
                        view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.main.keyFiguresCreated'));
                    }

                    response.data.data.forEach(entry => {
                        view.$set(view.planningIndicatorMap, entry.id, entry);
                    });
                    resolve();
                }).catch(function (error) {
                    if(toast){
                        view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.main.createKeyFiguresError'));
                    }

                    console.log(error)
                    reject(error);
                })
            });

        },
        importPlanningIndicators(indicators, toast = true) {
            let view = this;
            let url = '/api/sec/planningindicator/import';
            let params = {
                storeId: this.$store.state.storeId
            };

            let payload = {
                requests: indicators
            }
            return new Promise((resolve, reject) => {
                view.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    if(toast){
                        view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('indicator.main.keyFiguresImported'));
                    }

                    resolve();
                }).catch(function (error) {
                    if(toast){
                        view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('indicator.main.importKeyFiguresError'));
                    }

                    console.log(error)
                    reject(error);
                })
            });

        },
        openDeleteModal: function(row){
            this.currentPlanningIndicatorRow = row;

            this.planningIndicatorId = row.item.id;
            this.showModal('modal-deleteplanningIndicator');
        },
        deletePlanningIndicator: function(indicator){
            let view = this;
            let url = '/api/sec/planningindicator';

            url = this.$helpers.appendParam("id", indicator.id, url, '/api/sec/planningindicator');
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicator');


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {
                view.$delete(view.planningIndicatorMap, indicator.id);
                view.$helpers.success(view.$t('shift.template.deleted'), view.$t('indicator.main.keyFigureDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.ui.deleteFailed'), view.$t('indicator.main.deleteKeyFigureError'));
                console.log(error)
            })

        },

        openViewModal: function(row){
            this.currentPlanningIndicatorRow = row;
            this.planningIndicatorId = row.item.id;

            this.showModal('modal-viewplanningIndicator');
        },


        loadPlanningIndicatorTypes : function() {

        let url = '/api/sec/planningindicatortype';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planningindicatortype');


        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })

        },
        loadPlanningIndicators : function(from, to, planned = null, typeId = null, imported = null) {

            let url = '/api/sec/planningindicator';
            let params = {
                    storeId: this.$store.state.storeId,
                    from: from,
                    to: to,
            }
            if(planned != null){
                params.planned = planned;
            }
            if(typeId != null){
                params.typeId = typeId;
            }
            if(imported != null){
                params.imported = imported;
            }

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            })


        },
        loadPlanningIndicatorsGroupedByDay: function(from, to) {
            let url = '/api/sec/planningindicator/grouped';
            let params = {
                    storeId: this.$store.state.storeId,
                    from: from,
                    to: to,
            }
            if(this.minuteOffset != null){
                params.offset = this.minuteOffset;
            }

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            })

        },
        loadPlanningIndicatorsPagedCompletely : function(from, to, page = 1, data = [], typeId = null, planned = null) {

            let url = '/api/sec/planningindicator';
            let params = {
                    storeId: this.$store.state.storeId,
                    from: from,
                    to: to,
                    page: page,
            }
            if(typeId != null){
                params.typeId = typeId;
            }
            if(planned != null){
                params.planned = planned;
            }

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            }).then(response => {

                if (response.data.length < 1 ) {
                    return data;
                } else {
                    data.push(...response.data);
                    return this.loadPlanningIndicatorsPagedCompletely(from, to, page+1, data, typeId, planned);
                }


             })


        },
        updatePlanningIndicatorTypes: function(data) {

            let map = {};
            for (let i = 0; i < data.length; i++) {
                map[data[i].id] = data[i];
            }
            this.planningIndicatorTypeMap = map;
        },
        updatePlanningIndicators: function(data, map){


            for (let i = 0; i < data.length; i++) {
                this.$set(map, data[i].id, data[i]);
            }

            this.planningIndicatorMap = map;

        },

        hideModalWithoutReset (ref) {
            this.planningIndicatorerror=false;
            this.$refs[ref].hide();
        },
        resetPlanningIndicatorValues(){
            this.planningIndicator ={
            id: null,
            amount: 0,
            typeId: null,
            planned: true,
            fromDate: null,
            fromTime: null,
            toDate: null,
            toTime: null,
            description: "",

        }
        },
        hideModal (ref) {

            this.resetPlanningIndicatorValues();

            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        },

        exportCSV(){
            var date = new Date();
            let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [this.$t('store.settings.date')];
            Object.values(this.planningIndicatorTypeMap).forEach(type => {

                headers.push(type.name+this.$t('indicator.vlh.targetBubbleCaps'));
                headers.push(type.name+this.$t('roster.comp.actualBubble'));
            })



            let filename = 'Kennzahlen_'
            csv += headers.join(";");
            csv += "\n";
            if(!view.indicatorDateView) {
                filename += this.dateSelectionStart.format("MM-YYYY") + '_' + this.storeSettings.name + '_' + ts +  '.csv';

                let startDate = this.dateSelectionStart.clone().startOf('month');
                let endDate = startDate.clone().add(1,'months');
                while(startDate < endDate){
                    let dateKey = startDate.format("YYYY-MM-DD");
                    let cur = [startDate.format("DD.MM.YYYY")];
                    Object.values(this.planningIndicatorTypeMap).forEach(type => {
                        let val = 0;
                        if(view.indicatorsByDayMap[type.id] && view.indicatorsByDayMap[type.id].planned && view.indicatorsByDayMap[type.id].planned[dateKey]){
                            val = view.indicatorsByDayMap[type.id].planned[dateKey] / Math.pow(10, type.fractional)
                        }
                        cur.push((""+val).replace(".", ","));
                        val = 0;
                        if(view.indicatorsByDayMap[type.id] && view.indicatorsByDayMap[type.id].actual && view.indicatorsByDayMap[type.id].actual[dateKey]){
                            val = view.indicatorsByDayMap[type.id].actual[dateKey] / Math.pow(10, type.fractional)
                        }
                        cur.push((""+val).replace(".", ","));

                    })

                    csv += cur.join(";");
                    csv += "\n";

                    startDate.add(1, 'days');
                }
            } else {
                filename += view.indicatorDateView.format("DD-MM-YYYY") + '_' + this.storeSettings.name + '_' + ts +  '.csv';

                for(let x = 0; x < 24; x++) {

                    let date = view.indicatorDateView.clone().hours(x).minutes(0).seconds(0).millisecond(0);
                    let cur = [date.format("HH:mm")];



                    let dateKey = date.format("YYYY-MM-DD-HH");
                    if(this.planningIndicatorTimeMap[dateKey]){
                        Object.values(this.planningIndicatorTypeMap).forEach(type => {
                            let val = 0;
                            this.planningIndicatorTimeMap[dateKey].filter(entry => entry.indicator.planned === true && entry.indicator.typeId == type.id).forEach(entry => {
                                let i = entry.indicator;
                                val+= i.amount;
                            });
                            cur.push((""+(val/Math.pow(10, type.fractional))).replace(".", ","));
                            val = 0;
                            this.planningIndicatorTimeMap[dateKey].filter(entry => entry.indicator.planned === false && entry.indicator.typeId == type.id).forEach(entry => {
                                let i = entry.indicator;
                                val+= i.amount;
                            });
                            cur.push((""+(val/Math.pow(10, type.fractional))).replace(".", ","));


                        })

                    } else {
                        Object.values(this.planningIndicatorTypeMap).forEach(type => {
                            let val = 0;
                            cur.push(val);
                            cur.push(val);

                        })
                    }
                    csv += cur.join(";");
                    csv += "\n";
                }
            }





            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        exportForImportCSV(data, type){
            var date = new Date();
            let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );

            let view = this;
            let csvPre = "data:text/csv;charset=utf-8,";
            let csv = "";
            let headers = [this.$t('store.settings.date'), type.name];




            let filename = 'Kennzahlen_Export_'+type.name+'_'+this.dateSelectionStart.format("MM-YYYY") + '_' + this.storeSettings.name + '_' + ts +  '.csv';
            csv += headers.join(";");
            csv += "\n";
            data.forEach(entry => {
                let d = view.$helpers.getMomentFromStringTZ(entry.from);
                let cur = [d.format("DD.MM.YYYY HH:mm"), entry.amount/ Math.pow(10, type.fractional)];
                csv += cur.join(";");
                csv += "\n";
            })

            let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", filename);
            document.body.appendChild(link); // Required for FF

            link.click();
        },
  },


}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>

    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
    }

    .has-header > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    .header.top{
        margin: 10px 0;
    }
    .data-table{
        top: 10px;
        position: relative;
    }

    .header.date{
        display: inline-flex;
        justify-items: center;
        align-items: center;
        position: absolute;
        left: 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
        margin-top: -3px;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin-right: 5px;
        margin-top: -3px;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
        margin-top: -3px;
    }
    .header.date .fa-angle-left{
        margin: 0 10px;
        font-size: 25px;
        color: var(--contrast-4);
    }
    .indicator-view{
        padding: 30px;
        padding-bottom: 50px;
    }
</style>
